/* eslint-disable no-shadow */
export enum enumCommercialProductType {
  Server = 1,
  Rede = 2
}

export const enumCommercialProductTypeLabel = new Map<
  enumCommercialProductType,
  string
>([
  [enumCommercialProductType.Server, 'Servidores'],
  [enumCommercialProductType.Rede, 'Rede']
]);
/* eslint-enable no-shadow */
